import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const TransactionBulkScheduleCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedTransactionCount = 0,
        transactionBulkScheduleOptions = [],
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set recognition schedule for ${pluralizeWithCount("transaction", selectedTransactionCount)}`}
            options={transactionBulkScheduleOptions}
        />
    );
};
